<template>
    <div :class="$style.root">
        <a-form :form="form">
            <a-form-item>
                <a-input size="large" placeholder="请输入用户名" v-decorator="['username', formFields.account]">
                    <template #prefix>
                        <font-icon type="icon-yonghu" />
                    </template>
                </a-input>
            </a-form-item>
            <a-form-item>
                <a-input-password
                    size="large"
                    placeholder="请输入密码"
                    v-decorator="['password', formFields.password]">
                    <template #prefix>
                        <font-icon type="icon-mima" />
                    </template>
                </a-input-password>
            </a-form-item>
        </a-form>
        <div class="columns">
            <a-checkbox>记住密码</a-checkbox>
            <div class="whitespace"></div>
            <a-button type="link">忘记密码？</a-button>
        </div>
        <div class="columns">
            <a-button size="large" type="primary" class="column" block @click="onSubmit">登录</a-button>
            <div class="whitespace"></div>
            <a-button size="large" @click="onReset">重填</a-button>
        </div>
    <!-- <ForgetPassword /> -->
    </div>
</template>

<script>
    import { mapActions } from 'vuex';
    // import ForgetPassword from './ForgetPassword.vue';
    export default {
        name: 'FormPwdLogin',

        data() {
            return {
                form: this.$form.createForm(this),
                formFields: {
                    account: {
                        validateFirst: true,
                        validateTrigger: ['blur', 'change'],
                        rules: [{ required: true, message: '请输入手机号', whitespace: true }],
                    },
                    password: {
                        validateTrigger: ['blur', 'change'],
                        rules: [
                        ],
                    },
                },
            };
        },

        methods: {
            ...mapActions(['requestPasswordLogin', 'gerUserInfo']),

            // 提交表单
            onSubmit() {
                this.form.validateFields((err, values) => {
                    if (err) return;
                    this.requestPasswordLogin(values)
                        .then(() => {
                            this.$router.replace('/');
                            this.onReset();
                            this.$message.success('登录成功');
                        })
                        .catch(({ message }) => {
                            // this.onRefreshCode();
                            if (message) this.$message.error(message);
                        });
                });
            },

            onReset() {
                this.form.resetFields();
            },
        },
    };
</script>

<style lang="less" module>
    .root {
        width: 360px;
        margin: 0 auto;
    }
</style>
